import { useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';

/**
 * Shown in the native (iOS/Android) app in place of the web subscribe/billing
 * pages. Per App Store Guideline 3.1.1 the app must not offer account
 * registration or external subscription/payment mechanisms — so this screen
 * shows no prices, no checkout, and no link to purchase. Billing is handled on
 * the web. Deliberately plain text (not a tappable purchase link).
 */
export default function NativeSubscriptionNotice() {
  const navigate = useNavigate();

  const signOut = () => {
    authApi.logout().catch(() => {});
    localStorage.removeItem('manager_token');
    localStorage.removeItem('manager_refresh_token');
    localStorage.removeItem('manager_user');
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="max-w-md w-full text-center bg-white rounded-2xl border border-slate-200 p-8 shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">Manage your account on the web</h1>
        <p className="mt-3 text-slate-600">
          Your Mise plan and billing are managed from your web account. Sign in at
          lamise.app in a browser to start or update your subscription, then return
          here to sign in.
        </p>
        <button
          onClick={() => navigate('/login')}
          className="mt-6 w-full rounded-lg bg-primary-600 px-4 py-2.5 text-white font-medium hover:bg-primary-700 transition-colors"
        >
          Back to sign in
        </button>
        <button
          onClick={signOut}
          className="mt-3 w-full text-sm text-slate-500 hover:text-slate-700"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
